import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MuiIconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Badge from '@mui/material/Badge';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';

import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import { logout, selectUsuario } from "../reducers/authSlice";
import api from "../service/api";
// import NotificationsContainer from "./Notifications/NotificationsContainer";

const IconButton = styled(MuiIconButton)({
  padding: 0.5,
  marginRight: 1,
});

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    border: "1px solid #d3d4d5",
  },
}));

const Avisos = (props) => {
  const { anchorAvisos, handleCloseAvisos, avisos } = props;

  return (
    <Popover
      id="avisos-menu"
      open={Boolean(anchorAvisos)}
      anchorEl={anchorAvisos}
      onClose={handleCloseAvisos}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          width: "350px",
          maxWidth: "100%",
        }
      }}
    >
      <List>
        <ListSubheader component="div" id="avisos-subheader">
          AVISOS
        </ListSubheader>
        {avisos.map((aviso, index) => (
          <ListItem key={index} divider>
            <ListItemText
              primary={<><Typography variant="aclaracion">{aviso.fecha_desde}</Typography><Typography variant="body1">{aviso.titulo}</Typography></>}
              secondary={aviso.descripcion}
              secondaryTypographyProps={{ variant: "body2" }}
            />
          </ListItem>
        ))}
        {avisos.length === 0 ? (<>
          <ListItem key="sin-datos">
            <ListItemText
              secondary={"Sin novedades"}
              secondaryTypographyProps={{ variant: "aclaracion" }}
            />
          </ListItem>
        </>) : ""}
      </List>
    </Popover>
  );
};

const Notificaciones = (props) => {
  const { anchorNotificaciones, handleCloseNotificaciones, notificaciones } = props;

  return (
    <Popover
      id="notificacion-menu"
      open={Boolean(anchorNotificaciones)}
      anchorEl={anchorNotificaciones}
      onClose={handleCloseNotificaciones}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          width: "350px",
          maxWidth: "100%",
        }
      }}
    >
      <List>
        <ListSubheader component="div" id="notificaciones-subheader">
          NOTIFICACIONES
        </ListSubheader>
        {notificaciones.map((notificacion, index) => (
          <ListItemButton key={index} divider>
            <ListItemIcon>
              <FiberManualRecordIcon fontSize="small" color={notificacion.leido === "N" ? "primary" : "secondary"} />
            </ListItemIcon>
            <ListItemText
              primary={<><Typography variant="aclaracion">{notificacion.fecha_mensaje}</Typography><Typography variant="body1">{notificacion.titulo}</Typography></>}
              secondary={<><Typography variant="body1">{notificacion.descripcion}</Typography></>}
            />
          </ListItemButton>
        ))}
        {notificaciones.length === 0 ? (<>
          <ListItem key="sin-datos">
            <ListItemText
              secondary={"Sin novedades"}
              secondaryTypographyProps={{ variant: "aclaracion" }}
            />
          </ListItem>
        </>) : ""}
      </List>
    </Popover>
  );
};

const UserMenu = (props) => {
  const dispatch = useDispatch();
  const usuario = useSelector(selectUsuario);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorAvisos, setAnchorAvisos] = useState(null);
  const [avisos, setAvisos] = useState([]);
  const [avisosCant, setAvisosCant] = useState(0);
  const [anchorNotificaciones, setAnchorNotificaciones] = useState(null);
  const [notificaciones, setNotificaciones] = useState([]);
  const [notificacionesCant, setNotificacionesCant] = useState(0)

  const width = 600; // lo que mide de ancho la ventana popup
  const [width_pantalla] = useState(window.innerWidth); // lo que mide la pantalla completa

  const ajuste_orizontal = parseInt((width_pantalla - width) / 2);

  const handleClickNotificaciones = (event) => {
    marcarLeidas();
    setAnchorNotificaciones(event.currentTarget);
  };

  const marcarLeidas = async () => {
    try {
      await api.marcarLeidas();
    } catch (e) {
      console.log(e);
    }
  };

  const obtenerNotificaciones = async () => {
    try {
      let resultado = await api.obtenerNotificaciones();
      console.log(resultado.data.avisos);
      setAvisos(resultado.data.avisos);
      setAvisosCant(resultado.data.avisos.length);
      setNotificaciones(resultado.data.notificaciones);
      setNotificacionesCant(resultado.data.cantidad);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCloseNotificaciones = () => {
    setAnchorNotificaciones(null);
    obtenerNotificaciones();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleClickAvisos = (event) => {
    setAnchorAvisos(event.currentTarget);
  };

  const handleCloseAvisos = () => {
    setAnchorAvisos(null);
  };

  // const obtenerAvisos = async () => {
  //   try {
  //     let resultado = await api.obtenerNotificaciones();
  //     setAvisos(resultado.data);
  //     setAvisosCant(resultado.data.length);
  //     // setNotificaciones(resultado.data.notificaciones);
  //     // setNotificacionesCant(resultado.data.cantidad);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // useEffect(() => {
  //   obtenerAvisos();

  //   const interval = setInterval(() => {
  //     obtenerAvisos();
  //   }, 180000);

  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    obtenerNotificaciones();

    const interval = setInterval(() => {
      obtenerNotificaciones();
    }, 180000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Typography
        component="p"
        variant="body2"
        sx={{
          fontWeight: "bold",
          color: "gray",
          mr: 1,
          display: { xs: "none", md: "block" },
        }}
        noWrap
      >
        {usuario}
      </Typography>
      <Badge badgeContent={avisosCant} color="primary" variant="dot" sx={{ mr: 1 }}>
        <IconButton sx={{ color: "gray" }} onClick={handleClickAvisos} title="Avisos">
          <LanguageOutlinedIcon />
        </IconButton>
      </Badge>
      {/* <NotificationsContainer /> */}
      <Badge badgeContent={notificacionesCant} color="primary" variant="dot">
        <IconButton sx={{ color: "gray" }} onClick={handleClickNotificaciones} title="Notificaciones">
          <NotificationsOutlinedIcon />
        </IconButton>
      </Badge>
      <IconButton sx={{ color: "gray" }} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem component={Link} to="/perfil" onClick={handleClose}>
          <ListItemIcon>
            <PersonOutlineOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Perfil"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            window.open(
              "https://apps.entrerios.gov.ar/cambioclave/",
              "",
              "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=600, height=800, top=10, left=" + ajuste_orizontal + ""
            );
          }}
        >
          <ListItemIcon>
            <CreateOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Cambiar Contraseña"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            handleLogout();
            handleClose();
          }}
        >
          <ListItemIcon>
            <ExitToAppOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Cerrar Sesión"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
      </StyledMenu>

      <Avisos anchorAvisos={anchorAvisos} handleCloseAvisos={handleCloseAvisos} avisos={avisos} />
      <Notificaciones anchorNotificaciones={anchorNotificaciones} handleCloseNotificaciones={handleCloseNotificaciones} notificaciones={notificaciones} />
    </>
  );
};

export default UserMenu;
